module.exports = __webpack_public_path__ + "img/logo_canplast.5012059b.png";